import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import MarketingBudgetComp from './MarketingBudgetComp'

function MarketingBudget() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <MarketingBudgetComp/>      
        </div>
    </div>
  )
}

export default MarketingBudget